import React from 'react'

import { PageRender } from 'components/PageRender'
import { useAppInfo } from 'hooks/useAppInfo'
import { useUserSegmentation } from 'hooks/useUserSegmentation'
import { openDeeplink } from 'utils/helpers'

import * as S from '../styles'

export const ArSupport = () => {
  const { userSegmentation, pageStatus } = useUserSegmentation()

  const {
    languageDictionary: { support: dictionary },
  } = useAppInfo()

  return (
    <PageRender pageStatus={pageStatus}>
      <S.SupportContainer>
        <S.SupportCard>
          <S.SupportTitle>{dictionary.relationshipCenterTitle}</S.SupportTitle>
          <S.SupportInfo>{dictionary.relationshipCenterDescription}</S.SupportInfo>
          <S.ContactContainer>
            <S.Contact
              onClick={() =>
                openDeeplink(
                  dictionary.relationshipCenterContactDeepLink,
                  dictionary.relationshipCenterContactInfo,
                  userSegmentation,
                )
              }
            >
              {dictionary.relationshipCenterContact}
            </S.Contact>
            <S.ContactInfo>
              {dictionary.relationshipCenterContactInfoFirst} <br />
              {dictionary.relationshipCenterContactInfoLast}
            </S.ContactInfo>
          </S.ContactContainer>

          <S.ContactContainer>
            <S.Contact
              onClick={() =>
                openDeeplink(
                  dictionary.emailContactDeepLink,
                  dictionary.emailContact,
                  userSegmentation,
                )
              }
            >
              {dictionary.emailContact}
            </S.Contact>
          </S.ContactContainer>

          <S.Separator />

          <S.SupportInfo>{dictionary.privacyCenterDescription}</S.SupportInfo>
          <S.ContactContainer>
            <S.Contact
              onClick={() =>
                openDeeplink(
                  dictionary.privacyCenterContactDeepLink,
                  dictionary.privacyCenterContact,
                )
              }
            >
              {dictionary.privacyCenterContact}
            </S.Contact>
          </S.ContactContainer>
        </S.SupportCard>
      </S.SupportContainer>
    </PageRender>
  )
}
